import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Image from '@components/Image';
import headerPlaceholder from '@assets/images/loading-header.png';
import useIsDesktopLayout from '@hooks/useIsDesktopLayout';

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  width: ${({ large }) => (large ? '100px' : '50px')};
  height: ${({ large }) => (large ? '100px' : '50px')};
  ${({ isClosed }) => isClosed && `opacity: 0.5`};
`;

const StyledLogo = styled(Image)`
  width: ${({ large }) => (large ? '100px' : '50px')};
  height: ${({ large }) => (large ? '100px' : '50px')};
  border-radius: 6px;
  border: ${({ theme }) => `1px solid ${theme.colors.textSecondary}`};
  margin-left: 0;
`;
function Logo({ imageSrc, isClosed, name, ariaHidden }) {
  const isDesktop = useIsDesktopLayout();

  return (
    <LogoContainer isClosed={isClosed} large={isDesktop}>
      <StyledLogo
        src={imageSrc}
        placeholder={headerPlaceholder}
        large={isDesktop}
        alt={name}
        showErrorImage
        ariaHidden={ariaHidden}
      />
    </LogoContainer>
  );
}

Logo.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isClosed: PropTypes.bool.isRequired,
  ariaHidden: PropTypes.bool,
};

export default Logo;
